import { render, staticRenderFns } from "./index.vue?vue&type=template&id=286c0f23&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=286c0f23&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286c0f23",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('286c0f23')) {
      api.createRecord('286c0f23', component.options)
    } else {
      api.reload('286c0f23', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=286c0f23&scoped=true", function () {
      api.rerender('286c0f23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P3_Page/PrivacyAgreement/index.vue"
export default component.exports